import axios from 'axios'

export let baseURL = "https://board-api-development.berry-ai.com/"
if (process.env.REACT_APP_ENV === 'development')
{
  baseURL = "https://board-api-development.berry-ai.com/"
}
else if (process.env.REACT_APP_ENV === 'testing')
{
  baseURL = "https://board-api-testing.berry-ai.com/"
}
else
{
  baseURL = "https://board-api.berry-ai.com/"
}


export const api = axios.create({
  baseURL,
  timeout: 3 * 1000,
})
